$(function () {

    var _date_utils_get_week_day = function (date, short) {
        var day = date.getDay();

        switch (day) {
            case 0: return short ? "Sun" : "Sunday";
            case 1: return short ? "Mon" : "Monday";
            case 2: return short ? "Tue" : "Tuesday";
            case 3: return short ? "Wed" : "Wednesday";
            case 4: return short ? "Thu" : "Thursday";
            case 5: return short ? "Fri" : "Friday";
            case 6: return short ? "Sat" : "Saturday";
        }
    };

    var _date_utils_get_month = function (date, short) {
        var month = date.getMonth();

        switch (month) {
            case 0: return short ? "Jan" : "January";
            case 1: return short ? "Feb" : "February";
            case 2: return short ? "Mar" : "March";
            case 3: return short ? "Apr" : "April";
            case 4: return short ? "May" : "May";
            case 5: return short ? "Jun" : "June";
            case 6: return short ? "Jul" : "July";
            case 7: return short ? "Aug" : "August";
            case 8: return short ? "Sep" : "September";
            case 9: return short ? "Oct" : "October";
            case 10: return short ? "Nov" : "November";
            case 11: return short ? "Dec" : "December";
        }
    };

    var _date_utils_process_med_date = function (date) {
        var parsedDate = _date_utils_get_week_day(date) + ", " +
            date.getDate().toString() + " " +
            _date_utils_get_month(date, true) + " " +
            date.getFullYear().toString();

        return parsedDate;
    };

    var _date_utils_process_date = function (date) {
        var parsedDate = date.getDate().toString() + " " +
            _date_utils_get_month(date, false) + " " +
            date.getFullYear().toString();

        return parsedDate;
    };

    var _date_utils_get_time_12 = function (date) {
        var h = date.getHours();
        var m = date.getMinutes();
        var time = "";

        //append the hour
        if (h == 0) time = "12";
        else if (h > 12) time = (h - 12).toString();
        else time = h.toString();

        time += ":";

        //append the minutes
        if (m < 10) time += "0" + m.toString();
        else time += m.toString();

        time += " ";

        //append the meridian indicator
        time += (h >= 12 ? "PM" : "AM");

        return time;
    };

    var _date_utils_process_long_date = function (date) {
        var parsedDate = _date_utils_get_week_day(date) + ", " +
            date.getDate().toString() + " " +
            _date_utils_get_month(date, true) + " " +
            date.getFullYear().toString() + " " +
            _date_utils_get_time_12(date);

        return parsedDate;
    };

    var _date_utils_get_time_24 = function(date) {
        var h = date.getHours();
        var m = date.getMinutes();
        return h.toString() + ":" + m.toString();
    }

    var _date_utils_process_dates = function (element) {
        var type = $(element).attr("stems-date-type");
        var millis = $(element).attr("stems-date");
        type = type || "md-date";

        if (millis != null && millis != "null") {
            var date = new Date(parseInt(millis));

            if (type === "md-date") {
                $(element).html(_date_utils_process_med_date(date));
            }
            else if (type === "date") {
                $(element).html(_date_utils_process_date(date));
            }
            else if (type === "lg-date") {
                $(element).html(_date_utils_process_long_date(date));
            }
            else if (type === "time-12") {
                $(element).html(_date_utils_get_time_12(date));
            }
            else if (type === "time-24") {
                $(element).html(_date_utils_get_time_24(date));
            }
        }
    };

    $("[stems-date]").each(function () {
        _date_utils_process_dates(this)
    })

    $(document).ajaxComplete(function () {
        $("[stems-date]").each(function () {
            _date_utils_process_dates(this)
        })
    })
});